
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 100 100","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#a6bbc8","stroke-width":"2","fill":"none"}},[_c('path',{attrs:{"d":"M97.917 62.5c-6.904 0-12.5-5.596-12.5-12.5s5.596-12.5 12.5-12.5V22.917a4.167 4.167 0 00-4.167-4.167H6.25a4.167 4.167 0 00-4.167 4.167V37.5c6.904 0 12.5 5.596 12.5 12.5s-5.596 12.5-12.5 12.5v14.583A4.167 4.167 0 006.25 81.25h87.5a4.167 4.167 0 004.167-4.167V62.5zM33.333 66.667l33.334-33.334"}}),_c('circle',{attrs:{"cx":"37.5","cy":"37.5","r":"6.25"}}),_c('circle',{attrs:{"cx":"62.5","cy":"62.5","r":"6.25"}})])])
          )
        }
      }
    